import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const PLANS = [
  { name: 'Discovery Call', dur: '20 min', price: '₹250' },
  { name: 'Individual Session', dur: '60 min', price: '₹1,000', star: true },
  { name: '3-Session Package', dur: '3 × 60 min', price: '₹2,800', save: 'Save ₹200' },
  { name: '5-Session Package', dur: '5 × 60 min', price: '₹4,500', save: 'Save ₹500' }
];

export const PricingStrip = () => {
  return (
    <section className="py-12 bg-card border-y border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto text-center space-y-6">
          <div className="space-y-2">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-foreground">
              Simple, Honest Pricing
            </h2>
            <p className="text-sm text-muted-foreground">No hidden fees. Pay for what you book.</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {PLANS.map((p, i) => (
              <div key={i} className={`p-4 rounded-lg border-2 ${p.star ? 'border-primary bg-primary/5' : 'border-border bg-background'} relative`}>
                {p.star && (
                  <span className="absolute -top-2 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full">
                    Most Popular
                  </span>
                )}
                <p className="text-xs text-muted-foreground uppercase tracking-wide">{p.name}</p>
                <p className="text-2xl font-serif font-bold text-foreground mt-1">{p.price}</p>
                <p className="text-xs text-muted-foreground">{p.dur}</p>
                {p.save && <p className="text-xs text-emerald-700 font-semibold mt-1">{p.save}</p>}
              </div>
            ))}
          </div>
          <Link to="/services">
            <Button className="bg-primary hover:bg-primary/90" data-testid="pricing-view-all-btn">
              View All Services
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
